const initialState = {
    selectedMenus: []
  };
  
  const selectedMenusReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SELECTEDMENUS':
        if(!action.payload) {
          return initialState
        }
        else{
          return{
            ...state,
            selectedMenus : action.payload
          }
        }
      default:
        return state;
    }
  };
  
  export default selectedMenusReducer;